import {makeAutoObservable} from "mobx";
import {BaseLibraryEntity} from "../entity/base-library-entity";
import {PageEntity} from "../entity/page-entity";

export class BaseLibraryStore {

    constructor() {
        makeAutoObservable(this);
    }

    public condition: any = this.getDefaultCondition();
    public dataSource: BaseLibraryEntity[] = [];
    public selectRows: BaseLibraryEntity[] = [];
    public showBaseLibraryDetail:BaseLibraryEntity|undefined;
    public isShowDetail = false;
    public isShowEdit = false;
    public isShowUpload = false;
    public pagination:PageEntity = new PageEntity();
    public isShowDeleteCOnfirm = false;
    public deleteRecord!: BaseLibraryEntity;

    private getDefaultCondition() {
        return {
            speciesZhName: "", // 中文名
            canonicalName: "", //拉丁名
            speciesClass: "",
            speciesOrder: "",
            speciesFamily: "",
            speciesFamilyName: "",
            genus: "",
        };
    }

    public setDataSource(list: BaseLibraryEntity[]){
        this.dataSource = list;
    }


    public resetQueryCondition() {
        this.condition = this.getDefaultCondition();
    }

    public setSelectedRows(selectRows: BaseLibraryEntity[]){
        this.selectRows = selectRows;
    }

    public setBaseLibraryDetail(detail:BaseLibraryEntity) {
        this.showBaseLibraryDetail = detail;
    }

    public setShowDetail(isShow:boolean){
        this.isShowDetail = isShow;
    }

    public setShowEdit(isEdit:boolean){
        this.isShowEdit = isEdit;
    }

    public showDeleteConfirm(isShow:boolean){
        this.isShowDeleteCOnfirm = isShow;
    }

    public setDeleteRecord(record: BaseLibraryEntity) {
        this.deleteRecord = record;
    }

    public setShowUpload(isUpload:boolean) {
        this.isShowUpload = isUpload;
    }

    public clearSelectedRows(){
        this.selectRows = [];
    }

    public clear = () => {
        this.condition = this.getDefaultCondition();
        this.dataSource = [];
        this.selectRows = [];
        this.showBaseLibraryDetail = undefined;
        this.isShowDetail = false;
        this.isShowEdit = false;
        this.isShowUpload = false;
        this.pagination = new PageEntity();
        this.isShowDeleteCOnfirm = false;
        this.deleteRecord = {} as BaseLibraryEntity;
    }

}